function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  x: 73.42,
  y: 45.48,
  width: 88.75,
  height: 24.59,
  fill: "#786c64"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M173.17,654.8h0a8,8,0,0,1,8,8V753.3a8,8,0,0,1-8,8h0a8,8,0,0,1-8-8V662.83A8,8,0,0,1,173.17,654.8Z",
  transform: "translate(-114.91 -650.29)",
  fill: "#786c64"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M292.23,654.8h0a8,8,0,0,1,8,8V753.3a8,8,0,0,1-8,8h0a8,8,0,0,1-8-8V662.83A8,8,0,0,1,292.23,654.8Z",
  transform: "translate(-114.91 -650.29)",
  fill: "#786c64"
});

var _ref5 = /*#__PURE__*/React.createElement("rect", {
  x: 29.73,
  y: 32.36,
  width: 13.39,
  height: 50.86,
  rx: 1.64,
  fill: "#786c64"
});

var _ref6 = /*#__PURE__*/React.createElement("rect", {
  x: 192.47,
  y: 32.34,
  width: 13.39,
  height: 50.86,
  rx: 1.64,
  fill: "#786c64"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M116.55,697.41h21v21.31h-21a1.65,1.65,0,0,1-1.64-1.64v-18A1.64,1.64,0,0,1,116.55,697.41Z",
  transform: "translate(-114.91 -650.29)",
  fill: "#786c64"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M327.87,697.41h21a1.64,1.64,0,0,1,1.64,1.64v18a1.65,1.65,0,0,1-1.64,1.64h-21V697.41Z",
  transform: "translate(-114.91 -650.29)",
  fill: "#786c64"
});

var _ref9 = /*#__PURE__*/React.createElement("rect", {
  x: 78.62,
  y: 40.98,
  width: 88.75,
  height: 24.59,
  fill: "#efe8e1"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M178.37,650.29h0a8,8,0,0,1,8,8v90.47a8,8,0,0,1-8,8h0a8,8,0,0,1-8-8V658.32A8,8,0,0,1,178.37,650.29Z",
  transform: "translate(-114.91 -650.29)",
  fill: "#efe8e1"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M297.43,650.29h0a8,8,0,0,1,8,8v90.47a8,8,0,0,1-8,8h0a8,8,0,0,1-8-8V658.32A8,8,0,0,1,297.43,650.29Z",
  transform: "translate(-114.91 -650.29)",
  fill: "#efe8e1"
});

var _ref12 = /*#__PURE__*/React.createElement("rect", {
  x: 34.94,
  y: 27.85,
  width: 13.39,
  height: 50.86,
  rx: 1.64,
  fill: "#efe8e1"
});

var _ref13 = /*#__PURE__*/React.createElement("rect", {
  x: 197.67,
  y: 27.83,
  width: 13.39,
  height: 50.86,
  rx: 1.64,
  fill: "#efe8e1"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M121.75,692.9h21v21.31h-21a1.64,1.64,0,0,1-1.63-1.64v-18A1.64,1.64,0,0,1,121.75,692.9Z",
  transform: "translate(-114.91 -650.29)",
  fill: "#efe8e1"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M333.07,692.9h21a1.64,1.64,0,0,1,1.64,1.64v18a1.64,1.64,0,0,1-1.64,1.64h-21V692.9Z",
  transform: "translate(-114.91 -650.29)",
  fill: "#efe8e1"
});

var SvgLogoiconWeightboss = function SvgLogoiconWeightboss(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 240.78 111.04",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLogoiconWeightboss, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logoicon_weightboss.06da0977.svg";
export { ForwardRef as ReactComponent };